"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdFormik = require("cccisd-formik");
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _defaultFilterFields = _interopRequireDefault(require("./defaultFilterFields.js"));
var _cog = _interopRequireDefault(require("cccisd-icons/cog"));
var _style = _interopRequireDefault(require("./style.css"));
var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var FilterBar = function FilterBar(props) {
  var fields = props.fields,
    selectedFields = props.selectedFields,
    otherFields = props.otherFields,
    onSubmit = props.onSubmit,
    renderFilters = props.renderFilters;
  var initialValues = {};
  var _iterator = _createForOfIteratorHelper(fields),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var field = _step.value;
      initialValues[field.name] = field.initialValue || '';
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var _useState = (0, _react.useState)(initialValues),
    _useState2 = _slicedToArray(_useState, 2),
    previousValues = _useState2[0],
    setPreviousValues = _useState2[1];
  var actualFields = fields.filter(function (f) {
    return selectedFields.includes(f.name) && !otherFields.includes(f.name);
  }).map(function (f) {
    return _objectSpread(_objectSpread({}, _defaultFilterFields["default"][f.name]), f);
  });
  var otherFilterOptions = fields.filter(function (f) {
    return selectedFields.includes(f.name) && otherFields.includes(f.name);
  }).map(function (f) {
    return _objectSpread(_objectSpread({}, _defaultFilterFields["default"][f.name]), f);
  });
  var validateForm = function validateForm(values) {
    var errors = {};
    if (values.groupIds.length < 1) {
      errors.groupIds = "You must select at least one ".concat(props.userType === 'individuals' ? 'participant' : 'group', ".");
    }
    if (props.reportHandle && props.reportHandle === 'outcomes' && values.groupIds.length > 1) {
      errors.groupIds = "You cannot select more than one ".concat(props.userType === 'individuals' ? 'participant' : 'group', " for this report.");
    }
    if (values.startDate > values.endDate) {
      errors.startDate = 'Start Date must come before End Date';
    }
    return errors;
  };
  var setFilters = function setFilters(values) {
    setPreviousValues(values);
    onSubmit(values);
  };
  if (fields.length < 1) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
    initialValues: initialValues,
    onSubmit: setFilters,
    validate: validateForm,
    enableReinitialize: true,
    render: function render(formProps) {
      var valueChanged = !(0, _isEqual2["default"])(formProps.values, previousValues);
      var renderDefault = function renderDefault() {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].form
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].formFields
        }, actualFields.map(function (f) {
          return /*#__PURE__*/_react["default"].createElement(f.component, {
            key: f.name,
            settings: f,
            reportHandle: props.reportHandle,
            userType: props.userType
          });
        }), otherFilterOptions.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
          className: 'mb-3 ' + _style["default"].otherFilterBtn
        }, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
          title: "Other Filter Options",
          trigger: /*#__PURE__*/_react["default"].createElement("a", null, /*#__PURE__*/_react["default"].createElement(_cog["default"], {
            spaceRight: true
          }), "Other Filter Options"),
          size: "large",
          render: function render(_ref) {
            var closeModal = _ref.closeModal;
            return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
              className: _style["default"].otherFilterOptions
            }, otherFilterOptions.map(function (f) {
              return /*#__PURE__*/_react["default"].createElement(f.component, {
                key: f.name,
                settings: f
              });
            })), /*#__PURE__*/_react["default"].createElement("div", {
              className: _style["default"].buttons
            }, /*#__PURE__*/_react["default"].createElement("button", {
              type: "button",
              className: "btn btn-primary",
              onClick: closeModal
            }, "Close")));
          }
        }))), /*#__PURE__*/_react["default"].createElement("div", {
          className: "mb-3 ".concat(_style["default"].generateBtn)
        }, /*#__PURE__*/_react["default"].createElement("button", {
          className: "btn ".concat(valueChanged ? 'btn-warning' : 'btn-secondary ' + _style["default"].disabledBtn),
          type: "submit",
          disabled: !valueChanged
        }, valueChanged ? 'Apply Filters' : 'Filters Applied')));
      };
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, renderFilters ? renderFilters({
        formProps: formProps,
        props: props,
        actualFields: actualFields,
        otherFilterOptions: otherFilterOptions,
        valueChanged: valueChanged,
        renderDefault: renderDefault
      }) : renderDefault());
    }
  });
};
FilterBar.propTypes = {
  fields: _propTypes["default"].array,
  selectedFields: _propTypes["default"].array,
  otherFields: _propTypes["default"].array,
  onSubmit: _propTypes["default"].func,
  reportHandle: _propTypes["default"].string,
  userType: _propTypes["default"].string,
  renderFilters: _propTypes["default"].func
};
FilterBar.defaultProps = {
  fields: {}
};
var _default = exports["default"] = FilterBar;